(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/components/customer-service.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/components/customer-service.js');
"use strict";

const CustomerService = () => React.createElement("div", {
  className: "tg-customer-service center-text"
}, React.createElement("div", null, "Kontakta ", React.createElement("a", {
  className: "link",
  href: svs.core.urlMapping.get('customerServiceContact')
}, "Kundservice"), "."), React.createElement("div", null, "Telefon 0770-11 11 11."));
setGlobal('svs.ticket_gifts.redeem.components.CustomerService', CustomerService);

 })(window);